import { Badge, BadgeVariant } from "../Badge";

interface PlanBadgesProps {
  isPopular: boolean;
  hasLegacyDiscount: boolean;
  isTrialing: boolean;
  isTeamPlan: boolean;
}

export const PlanBadges = ({
  isPopular,
  hasLegacyDiscount,
  isTrialing,
  isTeamPlan,
}: PlanBadgesProps) => (
  <div className="absolute -top-3 left-1/2 flex w-full -translate-x-1/2 items-center justify-center gap-2">
    {isPopular && <Badge variant={BadgeVariant.BLUE} text="Popular" />}

    {hasLegacyDiscount && <Badge variant={BadgeVariant.GREEN} text="Loyalty Discount" />}

    {isTrialing && isTeamPlan && (
      <Badge variant={BadgeVariant.AMBER} text="Trial Active" showDot animate />
    )}
  </div>
);
